import React from "react";
import { ArrowUpRight, MessageCircle, Activity, Zap, Clock } from "lucide-react";
import { SITE } from "@/data/site";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="anasayfa"
      data-testid="hero-section"
      className="relative bg-blueprint-light overflow-hidden border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 lg:pt-24 pb-20 lg:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Text */}
          <div className="lg:col-span-7 rise-in">
            <div className="flex items-center gap-3 mb-6">
              <span className="divider-tick"></span>
              <span className="overline">S-01 / KESTİRİMCİ BAKIM</span>
            </div>
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-slate-900 leading-[1.05] tracking-tight"
              style={{ fontFamily: "Outfit" }}
            >
              Kestirimci Bakım &
              <br />
              <span className="text-cyan-600">Endüstriyel Servis</span> Çözümleri
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-600 leading-relaxed max-w-2xl">
              Titreşim analizi, online izleme, yerinde balans ve hizalama, fan/pompa
              revizyonu, makine taşıma-kurulum ve otomasyon. Saha ekibimiz ve ihtiyaca
              göre çözüm ağımızla, fabrikanın güvenilirliğini artırmaya yönelik
              kestirimci bakım çözümleri sunuyoruz.
            </p>

            {/* CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => scrollTo("iletisim")}
                data-testid="hero-quote-btn"
                className="btn-primary"
              >
                Teklif Al <ArrowUpRight className="w-4 h-4" />
              </button>
              <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-whatsapp-btn"
                className="btn-whatsapp"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp'tan Yaz
              </a>
            </div>

            {/* Mini stats */}
            <div className="mt-12 grid grid-cols-3 gap-4 max-w-2xl">
              <Stat icon={<Activity className="w-5 h-5" />} value="8+" label="Hizmet Alanı" />
              <Stat icon={<Clock className="w-5 h-5" />} value="HIZLI" label="Acil Destek Hattı" />
              <Stat icon={<Zap className="w-5 h-5" />} value="SAHA" label="Bölgesel Erişim" />
            </div>
          </div>

          {/* Visual block */}
          <div className="lg:col-span-5 rise-in" style={{ animationDelay: "120ms" }}>
            <div className="relative">
              {/* Decorative grid frame */}
              <div className="absolute -inset-4 border-2 border-cyan-600/20 rounded-sm pointer-events-none"></div>
              <div className="relative ind-card overflow-hidden">
                <img
                  src="/images/hero.jpg"
                  alt="Endüstriyel bakım sahası"
                  className="w-full h-[420px] object-cover"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="font-mono-accent text-xs text-cyan-300 tracking-[0.22em] uppercase mb-2">
                    LIVE / SAHA ÖLÇÜMÜ
                  </div>
                  <div className="text-xl font-semibold" style={{ fontFamily: "Outfit" }}>
                    Titreşim verisi · spektrum analizi · raporlama
                  </div>
                </div>
              </div>
              {/* Floating tag */}
              <div className="absolute -bottom-4 -left-4 bg-slate-900 text-white px-4 py-3 shadow-lg rounded-sm hidden sm:block">
                <div className="text-[10px] font-mono-accent text-cyan-400 tracking-[0.22em]">ISO 10816 · 20816</div>
                <div className="text-sm font-semibold">Standartlara uygun ölçüm</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ icon, value, label }) {
  return (
    <div className="border-l-2 border-cyan-600 pl-4">
      <div className="text-cyan-600 mb-1">{icon}</div>
      <div className="font-mono-accent text-2xl sm:text-3xl font-bold text-slate-900 leading-none">
        {value}
      </div>
      <div className="text-xs text-slate-600 mt-1 uppercase tracking-wider">{label}</div>
    </div>
  );
}
